module.exports = __webpack_public_path__ + "static/img/img29.83b0e08d.png";